export default __webpack_public_path__ + "static/media/brendon_1.70aa30f6.png";